import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
import claudia from './sidebarItems/claudia';

export const getSidebarItems = (
  accountId,
  locale = 'pt_BR',
  claudiaOnly = false,
  flags = {},
  {
    hasProjects = true,
    isHubAdmin = false,
    role = null,
    hasClaudiaInboxes = false,
  } = {}
) => ({
  primaryMenu: primaryMenu(accountId, locale, claudiaOnly, role),
  secondaryMenu: [
    conversations(accountId, claudiaOnly, {
      hasClaudiaInboxes,
      parallelConversationsEnabled: flags.parallelConversations,
    }),
    contacts(accountId),
    reports(accountId, flags, claudiaOnly),
    campaigns(accountId),
    settings(accountId, claudiaOnly, isHubAdmin),
    notifications(accountId),
    claudia(accountId, { hasProjects, isHubAdmin }),
  ],
});
